export default {
  site: {
    foreign_id: 'String',
    domain: 'String',
  },
}
